import React from 'react';
import { Link } from 'react-router-dom';

export default function PolicyPage({ title, children }) {
  return (
    <div className="min-h-screen bg-secondary-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to="/"
          className="inline-flex items-center text-primary-600 hover:text-primary-700 font-medium mb-8 transition-colors hover:underline underline-offset-2"
        >
          ← Back to home
        </Link>
        <article className="prose prose-green max-w-none">
          <h1 className="text-3xl font-bold text-secondary-900 mb-6">{title}</h1>
          <div className="text-secondary-700 space-y-4">{children}</div>
        </article>
      </div>
    </div>
  );
}
